import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "@/data/siteContent";

const AREA_IMG =
  "https://images.pexels.com/photos/31689116/pexels-photo-31689116.jpeg";

export default function ServiceAreas() {
  return (
    <section
      id="service-areas"
      data-testid="service-areas-section"
      className="relative py-20 md:py-32 bg-white dark:bg-[#0A2513]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <span className="inline-block text-xs uppercase tracking-[0.18em] font-semibold text-[#1F8A3A]">
              Service areas
            </span>
            <h2
              data-testid="service-areas-heading"
              className="mt-4 font-display text-3xl md:text-5xl font-semibold tracking-tight text-[#0E2A17] dark:text-[#F2FAF4]"
            >
              Proudly serving all of Toronto & the GTA.
            </h2>
            <p className="mt-5 text-base md:text-lg text-[#3F5549] dark:text-[#B9CDC0] max-w-xl leading-relaxed">
              From downtown condos to suburban basements — our crews are
              dispatched across the GTA daily. If your city is nearby, just
              ask.
            </p>

            <ul
              className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3"
              data-testid="service-areas-list"
            >
              {SERVICE_AREAS.map((area) => (
                <li
                  key={area}
                  className="flex items-center gap-2 text-[#0E2A17] dark:text-[#F2FAF4]"
                >
                  <MapPin className="h-4 w-4 text-[#1F8A3A] shrink-0" />
                  <span className="text-sm md:text-base">{area}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6">
            <div className="relative">
              <img
                src={AREA_IMG}
                alt="Toronto skyline"
                data-testid="service-areas-image"
                className="w-full h-[420px] md:h-[500px] object-cover rounded-3xl shadow-lg"
              />
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-[#0E2A17]/40 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div className="bg-white/90 backdrop-blur-sm rounded-2xl px-5 py-4 border border-white/60">
                  <div className="text-xs text-[#3F5549] dark:text-[#B9CDC0] uppercase tracking-wider">
                    Coverage
                  </div>
                  <div className="font-display text-2xl font-bold text-[#0E2A17] dark:text-[#F2FAF4]">
                    Toronto + GTA
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
